import * as Api from '@ViewModels';
import { invalidateMeetingPrepTemplates } from '../../../../queries/MeetingPrep/useMeetingPrepTemplates';

export interface BriefChatConfig {
	assistantName: string;
	resourceType: string;
	starterPrompts: string[];
	placeholder: string;
	onTurnComplete?: () => void;
}

export const EMAIL_EXEC_BRIEF_CHAT: BriefChatConfig = {
	assistantName: 'EmailExecBriefChatAgent',
	resourceType: Api.EMAIL_EXEC_DIGEST_RESOURCE_TYPE,
	starterPrompts: [
		'What needs a reply today?',
		'Summarize this brief in three bullets',
		'Draft a reply to the most urgent item',
		'Add the follow-ups as action items',
		'How does this compare with last week?',
	],
	placeholder: 'Ask me anything about this brief — I can also draft replies or add action items.',
};

export const MEETING_PREP_BRIEF_CHAT: BriefChatConfig = {
	assistantName: 'MeetingPrepBriefChatAgent',
	resourceType: Api.MEETING_PREP_BRIEF_RESOURCE_TYPE,
	starterPrompts: [
		'What should I know before this meeting?',
		'What did we last discuss with them?',
		'Draft an agenda',
		'Add a follow-up for after the meeting',
		'Send my briefs the evening before instead',
	],
	placeholder:
		'Ask me anything about this meeting — I can dig into your contacts, calendar and inbox, or change how Meeting Prep works.',
	onTurnComplete: invalidateMeetingPrepTemplates,
};

export const briefConversationFilter = (assistantName: string, resourceId: string): Api.AIConversationFilter => ({
	criteria: [
		{ property: Api.AIConversationFilterProperty.ResourceId, value: resourceId },
		{ property: Api.AIConversationFilterProperty.AssistantName, value: assistantName },
	],
});

export const briefResourceContexts = (resourceType: string, resourceId: string): Api.ResourceAIContext[] => [
	{
		_type: 'ResourceAIContext',
		resourceType,
		resourceId,
	} as Api.ResourceAIContext,
];

export const briefDrawerStateKey = (assistantName: string, resourceId: string) => `${assistantName}:${resourceId}`;
